module.exports = __webpack_public_path__ + "static/img/back_top.58acb1d.png";